export class LinkStatus {
    public static Linked: string = "Linked";
    public static NoLink: string = "No Link";
    public static InactiveLink:string = "Linked (Inactive)";
}
